import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { EUWDashboardTab } from './types';
import OverviewActiveIcon from 'assets/icons/submisison-overview-active';
import OverviewNoneActiveIcon from 'assets/icons/submisison-overview-none-active';
import ReportAndAnalyticsActiveIcon from 'assets/icons/report-and-analytics-active';
import ReportAndAnalyticsNonActiveIcon from 'assets/icons/report-and-analytics-non-active';

interface UWDashboardTabsProps {
  activeTab: string;
  setActiveTab: (key: EUWDashboardTab) => void;
}

const UWDashboardTabs: React.FC<UWDashboardTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const { t } = useTranslation();
  const underwriterDashboardTabs = [
    {
      key: EUWDashboardTab.OVERVIEW,
      label: (
        <span className="flex items-center gap-2">
          {activeTab === EUWDashboardTab.OVERVIEW ? (
            <OverviewActiveIcon />
          ) : (
            <OverviewNoneActiveIcon />
          )}
          {t('dashboard.overview')}
        </span>
      ),
    },
    {
      key: EUWDashboardTab.REPORT_ANALYTIC,
      label: (
        <span className="flex items-center gap-2">
          {activeTab === EUWDashboardTab.REPORT_ANALYTIC ? (
            <ReportAndAnalyticsActiveIcon />
          ) : (
            <ReportAndAnalyticsNonActiveIcon />
          )}
          {t('dashboard.reportAndAnalytics')}
        </span>
      ),
    },
  ];

  return (
    <Tabs
      activeKey={activeTab}
      onChange={(key) => setActiveTab(key as EUWDashboardTab)}
      items={underwriterDashboardTabs}
      className="uw-custom-tabs ant-tabs-tab"
    />
  );
};

export default UWDashboardTabs;
